import { app } from '../firebase';
import { getFirestore, getDoc, doc } from 'firebase/firestore';

const db = getFirestore(app);

const api = {
  loadGameSpec: async (gameId, language) => {
    // this conversion to string is needed for the Firestore document ID to work correctly, if it is not one, it gives an error when trying to get it
    gameId = String(gameId);
    const collectionName = `letroso-daily-${language}`;
    const docRef = doc(db, collectionName, gameId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return docSnap.data();
    } else {
      console.error(
        `No such document in collection ${collectionName} with ID ${gameId}`,
      );
      return null;
    }
  },
};

export default api;
